<div>
    <a routerLink="/inspection/unsynced" class="button margin-b--16" style="margin-top: 1%;">
        <i class="material-icons button__icon">&#xE5C4;</i>
        <span class="button__text">{{Translate('Back')}}</span>
    </a>
    <div *ngIf="_loading != 0">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <!-- Section A (Step1) -> No Equipment selected or created-->
    <div *ngIf="stepVisibility(1)" class="alert">
        <i class="material-icons alert__icon">warning</i>
        <div class="alert__content width-100">
            <span class="alert__content__title">{{ Translate('Awaiting Sync') }}</span>
            <div class="row">
                <div class="col-md-8">
                    <span class="alert__content__message">{{ Translate('This inspection was created on the mobile app, and requires you to match it with either existing equipment that has been setup, or to complete the setup of the new equipment.') }}</span>
                </div>
                <div class="col-md-3">
                    <mat-list role="list">
                        <mat-list-item role="listitem"><button (click)="_showSelectEquipmentModal = true" class="unsynced-page-button" mat-raised-button>{{Translate('Match to Existing Equipment')}}</button></mat-list-item>
            <mat-list-item role="listitem"><button (click)="goToEquipmentSetup()" class="unsynced-page-button unsynced-link-button" mat-raised-button>{{Translate('Setup New Equipment')}}</button></mat-list-item>
                    </mat-list>
                </div>
            </div>
        </div>
    </div>
    <!-- end of section A  -->
    <!-- Section B (Step 2) -> Equipment selected but it has not 4 systems  -->
    <div *ngIf="stepVisibility(2)" class="alert">
        <i class="material-icons alert__icon">warning</i>
        <div class="alert__content  width-100">
            <span class="alert__content__title">{{ Translate('Almost Ready to Sync') }}</span>
            <div class="row">
                <div class="col-md-8">
                    <span class="alert__content__message">{{ Translate('You have matched this inspection with an equipment. You need to complete the setup of the undercarriage on that equipment.') }}</span>
                    <span class="alert__content__message__sub">{{ Translate('You need to complete the setup of the undercarriage on that equipment.') }}</span>
                </div>
                <div class="col-md-3">
                    <mat-list role="list">
            <mat-list-item role="listitem"><button (click)="goToSetup()" class="unsynced-page-button" mat-raised-button>{{Translate('Finish Undercarriage Setup')}}</button></mat-list-item>
            <mat-list-item role="listitem"><button (click)="_showSelectEquipmentModal = true" class="unsynced-page-button" mat-raised-button>{{Translate('Match to Another Equipment')}}</button></mat-list-item>
                    </mat-list>
                </div>
            </div>
        </div>
    </div>
    <!-- end of section b  -->
    <!-- Section C (step 3) -> Undercarriage setup is done but not all components are matched  -->
    <div *ngIf="stepVisibility(3)" class="alert">
        <i class="material-icons alert__icon">warning</i>
        <div class="alert__content width-100">
            <span class="alert__content__title">{{ Translate('Almost Ready to Sync') }}</span>
            <span class="alert__content__message">{{ Translate('You have matched this inspection with an equipment.') }}</span>
            <div class="row">
                <div class="col-md-8">
                    <span class="alert__content__message__sub">{{ Translate('Below you can see that some components which were inspected are missinng from the equipment you have matched with.') }}</span>
                    <span class="alert__content__message">{{ Translate('You have 3 options:') }}</span>
                    <span class="alert__content__message">{{ Translate('1. Sync anyway, and lose the data for missing components.') }}</span>
                    <span class="alert__content__message">{{ Translate('2. Match to a different equipment if you accidentally selected the wrong one.') }}</span>
                    <span class="alert__content__message">{{ Translate('3. Edit the setup of the equipment you are currently matched with (only possible if this equipment is new).') }}</span>
                </div>
                <div class="col-md-3">
                    <mat-list role="list">
            <mat-list-item role="listitem"><button (click)="_showSubmitModal = true && SubmitMobileInspection()" [disabled]="_submitOperation.OperationSucceed" class="unsynced-page-button button-warning" mat-raised-button>{{Translate('Sync. I don\'t care about the data I will lose')}}</button></mat-list-item>
                        <mat-list-item role="listitem"><button (click)="goToSetup()" class="unsynced-page-button" mat-raised-button>{{Translate('Edit Equipment')}}</button></mat-list-item>
            <mat-list-item role="listitem"><button (click)="_showSelectEquipmentModal = true" class="unsynced-page-button" mat-raised-button>{{Translate('Match to Another Equipment')}}</button></mat-list-item>
                    </mat-list>
                </div>
            </div>
        </div>
    </div>
    <!-- end of section c  -->
    <!-- Section D (Step 4) -> ready for match without issue  -->
    <div *ngIf="stepVisibility(4)" class="alert">
        <i class="material-icons alert__icon">warning</i>
        <div class="alert__content width-100">
            <span class="alert__content__title">{{ Translate('Ready to Sync') }}</span>
            <div class="row">
                <div class="col-md-8">
                    <span class="alert__content__message">{{ Translate('You have matched this inspection with an equipment.') }}</span>
                </div>
                <div class="col-md-3">
                    <mat-list role="list">
            <mat-list-item role="listitem"><button (click)="_showSelectEquipmentModal = true" class="unsynced-page-button" mat-raised-button>{{Translate('Match to Another Equipment')}}</button></mat-list-item>
            <mat-list-item role="listitem"><button class="unsynced-page-button" mat-raised-button>{{Translate('Setup Undercarriage')}}</button></mat-list-item>
            <mat-list-item role="listitem"><button class="unsynced-page-button button-success" (click)="_showSubmitModal = true && SubmitMobileInspection()" [disabled]="_submitOperation.OperationSucceed" mat-raised-button>{{Translate('Sync')}}</button></mat-list-item>
                    </mat-list>

                </div>
            </div>
        </div>
    </div>
    <!-- end of section d  -->

  <div *ngIf="unSyncedInspectionId != 0" class="panel">
    <div class="panel__header">
      <span class="panel__header__title">
        {{Translate('Inspection Details')}}
      </span>
    </div>
    <div class="panel__content">
      <div class="column-container">
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{Translate('Customer')}}
            </span>
            <span class="text-block__important">
              {{inspection.Customer}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{Translate('Job Site')}}
            </span>
            <span class="text-block__important">
              {{inspection.JobSiteDetails.JobSiteName}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{Translate('Serial Number')}}
            </span>
            <span class="text-block__important">
              {{inspection.Serial}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{Translate('Unit Number')}}
            </span>
            <span class="text-block__important">
              {{inspection.UnitNumber}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{Translate('Model')}}
            </span>
            <span class="text-block__important">
              {{inspection.Model}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{Translate('Meter Reading (SMU/Hourmeter)')}}
            </span>
            <div *ngIf="inspection.SMU !=null">
              <click-to-edit [editable]="true" [data]="inspection.SMU" (dataChanged)="updateSMU($event)" [alignRight]="true">
              </click-to-edit>
            </div>


          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{Translate('Inspection Date')}}
            </span>
            <span class="text-block__important">
              {{inspection.InspectionDate}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <table>
            <tr>
              <td></td>
              <td class="text--label padding-lr--24">{{Translate('Left')}}</td>
              <td class="text--label padding-lr--24">{{Translate('Right')}}</td>
            </tr>
            <tr>
              <td class="text--label padding-tb-4">{{Translate('Track Sag')}}</td>
              <td class="text--important padding-lr--24">{{inspection.JobSiteDetails.TrakSagLeft}}</td>
              <td class="text--important padding-lr--24">{{inspection.JobSiteDetails.TrakSagRight}}</td>
            </tr>
            <tr>
              <td class="text--label padding-tb-4">{{Translate('No. Dry Joints')}}</td>
              <td class="text--important padding-lr--24">{{inspection.JobSiteDetails.DryJointsLeft}}</td>
              <td class="text--important padding-lr--24">{{inspection.JobSiteDetails.DryJointsRight}}</td>
            </tr>
            <tr>
              <td class="text--label padding-tb-4">{{Translate('Cannon Extension')}}</td>
              <td class="text--important padding-lr--24">{{inspection.JobSiteDetails.ExtCannonLeft}}</td>
              <td class="text--important padding-lr--24">{{inspection.JobSiteDetails.ExtCannonRight}}</td>
            </tr>
            <tr>
              <td class="text--label padding-tb-4">{{Translate('Scallop Measurement')}}</td>
              <td class="text--important padding-lr--24">{{inspection.JobSiteDetails.ScallopMeasurementLeft}}</td>
              <td class="text--important padding-lr--24">{{inspection.JobSiteDetails.ScallopMeasurementRight}}</td>
            </tr>
            <tr>
              <td class="text--label padding-tb-4">{{Translate('Link Count')}}</td>
              <td class="text--important padding-lr--24">{{inspection.JobSiteDetails.LinkCountLeft}}</td>
              <td class="text--important padding-lr--24">{{inspection.JobSiteDetails.LinkCountRight}}</td>
            </tr>
          </table>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{Translate('Impact')}}
            </span>
            <span class="text-block__important">
              {{inspection.JobSiteDetails.Impact}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{Translate('Abrasive')}}
            </span>
            <span class="text-block__important">
              {{inspection.JobSiteDetails.Abrasive}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{Translate('Moisture')}}
            </span>
            <span class="text-block__important">
              {{inspection.JobSiteDetails.Moisture}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{Translate('Packing')}}
            </span>
            <span class="text-block__important">
              {{inspection.JobSiteDetails.Packing}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="unSyncedInspectionId != 0" class="panel">
    <div class="panel__header">
      <span class="panel__header__title">
        {{Translate('Notes')}}
      </span>
    </div>
    <div class="panel__content">
      <div class="text-block">
        <span class="text-block__label">
          {{Translate('Inspection Notes')}}
        </span>
        <span class="text-block__important">
          {{inspection.InspectionNotes}}
        </span>
      </div>
      <div class="text-block">
        <span class="text-block__label">
          {{Translate('Job Site Notes')}}
        </span>
        <span class="text-block__important">
          {{inspection.JobSiteDetails.JobSiteNotes}}
        </span>
      </div>
    </div>
  </div>



  <div *ngIf="unSyncedInspectionId != 0" class="panel">
    <div class="panel__header">
      <span class="panel__header__title">
        {{Translate('Left Side Components')}}
      </span>
    </div>
    <div class="panel__content no-padding">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th>{{Translate('Component')}}</th>
            <th>{{Translate('Position')}}</th>
            <th>{{Translate('Measurement (mm)')}}</th>
            <th>{{Translate('Photo')}}</th>
            <th>{{Translate('Comment')}}</th>
            <th>{{Translate('Recommendations')}}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let component of leftComponents" [ngClass]="{'not-matched-component':component.ComponentId == 0}">
            <td>{{component.Component}}</td>
            <td>{{component.Position}}</td>
            <td>{{component.Reading}}</td>
            <td class="no-padding-tb" *ngIf="component?.Images?.length > 0">
              <span *ngFor="let image of component?.Images">
                <img (click)="showImage(image)" [src]="getImage(image)" class="inspection-observation-photo" />
              </span>
            </td>
            <td class="no-padding-tb" *ngIf="component?.Images?.length == 0">
              <a class="button button--faded">
                <i class="material-icons button__icon">camera_alt</i>
                <span class="button__text">{{Translate('View')}}</span>
              </a>
            </td>
            <td class="no-padding-tb" *ngIf="component?.Comments?.length > 0">
              <a class="button" (click)="showComment(component)">
                <i class="material-icons button__icon">textsms</i>
                <span class="button__text">{{Translate('View')}}</span>
              </a>
            </td>
            <td class="no-padding-tb" *ngIf="component?.Comments?.length == 0">
              <a class="button button--faded">
                <i class="material-icons button__icon">textsms</i>
                <span class="button__text">{{Translate('View')}}</span>
              </a>
            </td>
            <td class="no-padding-tb" *ngIf="component?.Recommendations?.length > 0">
              <a class="button" (click)="showRecommendations(component)">
                <i class="material-icons button__icon">textsms</i>
                <span class="button__text">{{Translate('View')}}</span>
              </a>
            </td>
            <td class="no-padding-tb" *ngIf="component?.Recommendations?.length == 0">
              <a class="button button--faded">
                <i class="material-icons button__icon">textsms</i>
                <span class="button__text">{{Translate('View')}}</span>
              </a>
            </td>
            <td class="no-padding-tb">
              <i *ngIf="component.IsFlagged==true" title="Flagged Component" class="material-icons" style="color:red;cursor: pointer;" (click)="OpenMblFlaggedComponent(component.Id, component.ComponentTypeId, component.ComponentId)">flag</i>
              &nbsp;
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="unSyncedInspectionId != 0" class="panel">
    <div class="panel__header">
      <span class="panel__header__title">
        {{Translate('Right Side Components')}}
      </span>
    </div>
    <div class="panel__content no-padding">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th>{{Translate('Component')}}</th>
            <th>{{Translate('Position')}}</th>
            <th>{{Translate('Measurement (mm)')}}</th>
            <th>{{Translate('Photo')}}</th>
            <th>{{Translate('Comment')}}</th>
            <th>{{Translate('Recommendations')}}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let component of rightComponents" [ngClass]="{'not-matched-component':component.ComponentId == 0}">
            <td>{{component.Component}}</td>
            <td>{{component.Position}}</td>
            <td>{{component.Reading}}</td>
            <td class="no-padding-tb" *ngIf="component?.Images?.length > 0">
              <span *ngFor="let image of component?.Images">
                <img (click)="showImage(image)" [src]="getImage(image)" class="inspection-observation-photo" />
              </span>
            </td>
            <td class="no-padding-tb" *ngIf="component?.Images?.length == 0">
              <a class="button button--faded">
                <i class="material-icons button__icon">camera_alt</i>
                <span class="button__text">{{Translate('View')}}</span>
              </a>
            </td>
            <td class="no-padding-tb" *ngIf="component?.Comments?.length > 0">
              <a class="button" (click)="showComment(component)">
                <i class="material-icons button__icon">textsms</i>
                <span class="button__text">{{Translate('View')}}</span>
              </a>
            </td>
            <td class="no-padding-tb" *ngIf="component?.Comments?.length == 0">
              <a class="button button--faded">
                <i class="material-icons button__icon">textsms</i>
                <span class="button__text">{{Translate('View')}}</span>
              </a>
            </td>
            <td class="no-padding-tb" *ngIf="component?.Recommendations?.length > 0">
              <a class="button" (click)="showRecommendations(component)">
                <i class="material-icons button__icon">textsms</i>
                <span class="button__text">{{Translate('View')}}</span>
              </a>
            </td>
            <td class="no-padding-tb" *ngIf="component?.Recommendations?.length == 0">
              <a class="button button--faded">
                <i class="material-icons button__icon">textsms</i>
                <span class="button__text">{{Translate('View')}}</span>
              </a>
            </td>
            <td class="no-padding-tb">
              <i *ngIf="component.IsFlagged==true" title="Flagged Component" class="material-icons" style="color:red;cursor: pointer;" (click)="OpenMblFlaggedComponent(component.Id, component.ComponentTypeId, component.ComponentId)">flag</i>
              &nbsp;
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="unSyncedInspectionId != 0" class="panel">
    <div class="panel__header">
      <span class="panel__header__title">
        {{Translate('Additional Observations')}}
      </span>
    </div>
    <div class="panel__content">
      <div class="table-container" [@slideOut]>
        <table class="table table--full-width table--striped">
          <thead>
            <tr>
              <th>{{'Description' | translate | async}}</th>
              <th>{{'Answer' | translate | async}}</th>
              <th>{{'Image' | translate | async}}</th>
              <th>{{'Comment' | translate | async}}</th>
            </tr>
          </thead>
          <tbody *ngIf="inspection.MblAdditionalObservations?.length > 0" [@slideOut]>
            <tr *ngFor="let ob of inspection.MblAdditionalObservations">
              <td> {{ob.Description}} </td>
              <td>
                <div *ngFor="let Answer of ob.Answers">{{Answer}}</div>
              </td>
              <td class="inspection-component-photo">
                <img *ngFor="let photo of ob.Images" (click)="showObsImage(photo)" class="inspection-observation-photo" [src]="getImage(photo)" />
              </td>
              <td> {{ob.Comment}} </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div (click)="modalClicked(1,0);" class="modal" *ngIf="showImagePopUp">
    <div (click)="modalClicked(0,0);" class="modal__content">
        <div class="modal__image">
            <img src="{{componentImageSrc}}" />
        </div>
    </div>
</div>
<div (click)="modalClicked(1,1);" class="modal" *ngIf="showCommentPopUp">
    <div (click)="modalClicked(0,1);" class="modal__content">
        <div class="modal__comment">
            {{componentComment}}
        </div>
    </div>
</div>

<div class="modal" *ngIf="_showSelectEquipmentModal">
    <div class="modal__content">
        <div class="row">
            <div class="col-md-6 col-md-offset-3">
                <h3>
                    {{Translate('Match with equipment')}}
                </h3>
                <form>
                    <mat-form-field class="setup-form-full-width">
                        <mat-select (selectionChange)="customerChanged($event)" name="customer" [(ngModel)]="_currentSelection.customer" placeholder="{{Translate('Select Customer')}}">
                            <mat-option *ngFor="let customer of _dropDownListsFiltered.customerList" [value]="customer">
                                {{ customer.Title }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="setup-form-full-width">
                        <mat-select (selectionChange)="jobsiteChanged($event)" name="jobsite" [(ngModel)]="_currentSelection.jobSite" placeholder="{{Translate('Select Job Site')}}">
                            <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
                                {{ jobsite.Title }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- <mat-form-field class="setup-form-full-width">
                        <mat-select (selectionChange)="equipmentChanged($event)" name="equipment" placeholder="{{Translate('Select Equipment')}}">
                            <mat-option *ngFor="let equipment of _dropDownListsFiltered.equipmentList" [value]="equipment">
                                {{ equipment.Serial }} | {{equipment.Unit}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field> -->


<mat-form-field class="setup-form-full-width">

    <mat-label>Select Equipment</mat-label>

    <input
        matInput
        [(ngModel)]="searchEquipment"
        (ngModelChange)="filterEquipment()"
        [matAutocomplete]="auto"
        name="equipment">

    <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayEquipment"
        (optionSelected)="equipmentChanged($event)">

        <mat-option
            *ngFor="let equipment of _dropDownListsFiltered.equipmentList"
            [value]="equipment">

            {{ equipment.Serial }} | {{ equipment.Unit }}

        </mat-option>

    </mat-autocomplete>

</mat-form-field>
                    
                </form>
                <div class="button-row text-center">
                    <button mat-raised-button (click)="cancelEquipmentSelection()">{{Translate('Cancel')}}</button>
                    <button mat-raised-button (click)="equipmentSubmitted()" [disabled]="_currentSelection.equipment.Id == 0 || _loading != 0" color="primary">{{Translate('Submit')}}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="_showSubmitModal" class="modal">
    <div class="modal__content">
        <mat-card>
            <mat-card-header>
                <mat-card-title>
                    {{Translate('Submit Unsynced Inspection')}}
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-spinner *ngIf="_loading != 0"></mat-spinner>
                <p *ngIf="_loading == 0">
                    {{Translate(messageboxcontent)}}
                </p>
            </mat-card-content>
            <mat-card-actions>
                <button mat-raised-button (click)="_showSubmitModal = false" [disabled]="_loading != 0"> {{Translate('Cancel')}} </button>
                <!-- <button mat-raised-button color="warn" (click)="SubmitMobileInspection()" [disabled]="_loading != 0 || _submitOperation.OperationSucceed"> {{Translate('Continue')}} </button> -->
</mat-card-actions>
        </mat-card>
    </div>
</div>
